import {
  ActionButton,
  CommandBarButton,
  CommandButton,
  DefaultButton,
  IButtonProps,
  IconButton,
  ISpinButtonProps,
  MessageBarButton,
  Position,
  PrimaryButton,
  SpinButton,
} from '@fluentui/react';

export interface IPButtonProps extends IButtonProps {}

// ActionButton
export const IPActionButton = (props: IPButtonProps) => {
  return <ActionButton {...props} />;
};

// CommandBarButton
export const IPCommandBarButton = (props: IPButtonProps) => {
  return <CommandBarButton {...props} />;
};

// CommandButton
export const IPCommandButton = (props: IPButtonProps) => {
  return <CommandButton {...props} />;
};

// DefaultButton
export const IPDefaultButton = (props: IPButtonProps) => {
  return <DefaultButton {...props} />;
};

// IconButton
export const IPIconButton = (props: IPButtonProps) => {
  return <IconButton {...props} />;
};

// MessageBarButton
export const IPMessageBarButton = (props: IPButtonProps) => {
  return <MessageBarButton {...props} />;
};

// PrimaryButton
export const IPPrimaryButton = (props: IPButtonProps) => {
  return <PrimaryButton {...props} />;
};

// SpinButton
export interface IPSpinButtonProps extends ISpinButtonProps {}
export { Position as IPSpinButtonPosition } 

export const IPSpinButton = (props: IPSpinButtonProps) => {
  return <SpinButton {...props} />;
};